import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractModal, ModalButtonModel, ModalButtonType } from '@cv-invision/core';
import { ClipboardService } from 'ngx-clipboard';
import * as vkbeautify from 'vkbeautify';

@Component({
	selector: 'cv-invision-request-information',
	templateUrl: './request-information.component.html',
	styleUrls: ['./request-information.component.scss']
})
export class RequestInformationComponent extends AbstractModal implements OnInit {
	@ViewChild('markupEditor', { static: false }) markupEditor;
	@ViewChild('markupEditor1', { static: false }) markupEditor1;
	@ViewChild('markupEditor2', { static: false }) markupEditor2;
	requestInformation: any;
	responseInformation: any;
	orderApiResponseInformation: any;
	copyRequest: Array<ModalButtonModel>;
	copyResponse: Array<ModalButtonModel>;
	copyApiResponse: Array<ModalButtonModel>;
	constructor(private clipboarService: ClipboardService) {
		super();
	}

	ngOnInit(): void {
		const { request, response, orderApiResponse } = this.data.reuqest;
		this.copyRequest = [];
		const resquestButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.requestInformation)
		};
		this.copyRequest.push(resquestButton);

		this.copyResponse = [];
		const responseButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.responseInformation)
		};
		this.copyResponse.push(responseButton);

		this.copyApiResponse = [];
		const apiResponseButton: ModalButtonModel = {
			class: 'copy-button',
			icon: 'fad fa-copy',
			type: ModalButtonType.ACTION,
			action: () => this.onCopycode(this.orderApiResponseInformation)
		};
		this.copyApiResponse.push(apiResponseButton);

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onDismiss.bind(this)
		};
		this.buttons.push(cancelButton);

		// parse json data
		this.requestInformation = this.parseJsonData(request);
		this.responseInformation = this.parseJsonData(response);
		this.orderApiResponseInformation = this.parseJsonData(orderApiResponse);

		setTimeout(() => {
			this.markupEditor.init();
			this.markupEditor1.init();
			this.markupEditor2.init();
		}, 200);
	}

	onDismiss(): void {
		super.onCancel();
	}

	/**
	 * parse josn strin from the server
	 * @param info
	 */
	parseJsonData(info: string): string {
		try {
			return JSON.stringify(JSON.parse(info), null, 3);
		} catch (e) {
			const data = JSON.parse(JSON.stringify(info, null, 1));
			return vkbeautify.xml(data);
		}
	}

	/***
	 * copy response code
	 */
	onCopycode(source: string): void {
		this.clipboarService.copy(source);
	}
}
